export default "__VITE_ASSET__yykPjU5i__"